import { Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IFund from '../../../../../interfaces/fund/IFund';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
import { TInvestFundLabelTag } from '../../../../../types/fund/TInvestFundLabelTag';

type CFiltersLabelSelectProps = {
	optionsLabels: { id: TInvestFundLabelTag; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
	label: string;
	multipleRenderLabelLangTag: string;
};

const CFiltersLabelSelect = (props: CFiltersLabelSelectProps) => {
	const { optionsLabels, filters, onChange, label, multipleRenderLabelLangTag } = props;

	const { t } = useTranslation();

	return (
		<>
			{optionsLabels ? (
				<CAppFilterSelect
					className="filter-labels"
					multiple
					multipleRenderTags={(val: IFund[]) => (
						<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
							{t(multipleRenderLabelLangTag, { count: val ? val.length : 0 })}
						</Box>
					)}
					value={filters?.labels ? optionsLabels.filter((x) => filters.labels?.includes(x.id)) : null}
					onChange={(val: { id: TInvestFundLabelTag; name: string }[]) =>
						onChange({
							...filters,
							labels: val ? val.map((x) => x.id) : null,
						})
					}
					label={label}
					size="small"
					options={optionsLabels}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default CFiltersLabelSelect;
